import { Component, OnDestroy, OnInit } from "@angular/core";
import { ContactService } from "../../contact.service";
import { ContactList } from "../../models/contact-list.model";
import { PaginationDto } from "src/app/core/dto/pagination.dto";
import { FormBuilder, FormGroup } from "@angular/forms";
import { GetContactListResponseDTO } from "../../dtos/get-contact-list-response.dto";
import { debounceTime, Subject, takeUntil } from "rxjs";
import { GetContactListRequestDTO } from "../../dtos/contact-list-request.dto";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AddAttendantModalComponent } from "./components/add-attendant-modal/add-attendant-modal.component";
import { ProjetoFormModalComponent } from "../../../projects/pages/projeto-form-modal/projeto-form-modal.component";
import { ConfirmationDialogService } from "src/app/shared/confirmation-dialog/confirmation-dialog.service";
import { ToastService } from "src/app/shared/toasts/toast-service";
import { ErrorMessagesService } from "src/app/shared/messages/services/error-messages.service";
import { AuthService } from "src/app/core/services/auth/auth.service";
import { Location } from '@angular/common';

@Component({
  selector: "app-get-lists",
  templateUrl: "./get-lists.component.html",
  styleUrl: "./get-lists.component.scss",
})
export class GetListsComponent implements OnInit, OnDestroy {
  breadCrumbItems!: Array<{}>;
  private readonly destroy$ = new Subject<void>();
  lists: ContactList[] = [];
  pagination: PaginationDto = {
    paginaAtual: 1,
    quantidadePorPagina: 10,
    totalDeItens: 0,
    ultimaPagina: 1,
  };
  isLoading = false;
  error = "";
  erro403 = false;

  // permisoes
  podeEditar = false;

  filterForm: FormGroup;
  teste = 10
  constructor(
    private contactService: ContactService,
    private fb: FormBuilder,
    private modalService: NgbModal,
    private confirmationModalService: ConfirmationDialogService,
    private toastService: ToastService,
    private errorMessagesService: ErrorMessagesService,
    private authService: AuthService,
    private location: Location
  ) {
    this.filterForm = this.fb.group({
      "Paginacao.PaginaAtual": [1],
      "Paginacao.QuantidadePorPagina": [10],
      Nome: [""],
    });
  }

  ngOnInit(): void {
    this.breadCrumbItems = [
      { label: "Contatos" },
      { label: "Contatos Gerados", active: true },
    ];

    this.permissaoAdicionarUsuario();

    this.getContactList(this.filterForm.value);
    this.filterForm.valueChanges
      .pipe(debounceTime(400))
      .subscribe((filters) => {
        this.getContactList(filters);
      });
  }

  getContactList(filters: GetContactListRequestDTO) {
    this.isLoading = true;
    this.contactService
      .getContactList(filters)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response: GetContactListResponseDTO) => {
          this.lists = response.listaContatosGerados;
          this.pagination = response.paginacao;
          this.isLoading = false;
        },
        error: (error) => {

          if (error.status == 403) {
            this.erro403 = true;
            return;
          } 
          
         this.error = this.errorMessagesService.getMessage('ERR_0007');
        }
      });
  }

  onPageChange(page: number) {
    this.filterForm.patchValue({
      "Paginacao.PaginaAtual": page,
    });
  }

  onAddContact(list: ContactList) {
    const modalRef = this.modalService.open(ProjetoFormModalComponent, { 
      size: 'md',
      backdrop: 'static'
    });
    modalRef.componentInstance.modoAdicionarContato = true;
    modalRef.componentInstance.listaContato = list;
    modalRef.result.then((result) => {
      if (result) {
        // Recarregar a lista após adicionar contato
        this.getContactList(this.filterForm.value);
      }
    }).catch(() => {
      // Modal foi fechado sem salvar
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onArchive(list: ContactList) {
    this.confirmationModalService
      .confirm(
        "Arquivar lista",
        `A Lista ficará indisponível se prosseguir. Deseja arquivar a lista ${list.nomeLista}?`,
      )
      .then((confirmed) => {
        if (confirmed) {
          this.contactService.arquivarLista(list.id).subscribe({
            next: () => {
              this.toastService.show("Lista arquivada com sucesso", {
                classname: "bg-success text-light",
              });
              this.getContactList(this.filterForm.value);
            },
            error: (error) => {
              const mensagens = error?.error?.errors?.Mensagens;

              const mensagemErro = Array.isArray(mensagens) && mensagens.length > 0
                ? mensagens[0]
                : this.errorMessagesService.getMessage('ERR_0008');

              this.toastService.show(mensagemErro, {
                classname: "bg-danger text-light",
              });
            },
          });
        }
      });
  }

  onDelete(list: ContactList) {
    this.confirmationModalService
      .confirm(
        "Excluir lista",
        `Essa ação ira excluir a lista ${list.nomeLista} e não poderá ser desfeita.`,
      )
      .then((confirmed) => {
        if (confirmed) {
          this.contactService.deleteContactList(list.id).subscribe({
            next: () => {
              this.toastService.show("Lista excluída com sucesso", {
                classname: "bg-success text-light",
              });
              this.getContactList(this.filterForm.value);
            },
            error: (error) => {
              const mensagens = error?.error?.errors?.Mensagens;

              const mensagemErro = Array.isArray(mensagens) && mensagens.length > 0
                ? mensagens[0]
                : this.errorMessagesService.getMessage('ERR_0008');

              this.toastService.show(mensagemErro, {
                classname: "bg-danger text-light",
              });
            },
          });
        }
      });
  }

  permissaoAdicionarUsuario(): void {
    this.podeEditar = this.authService.verificarPermissao('Call_Contatos_Gerados', 'Editar')
  }

  voltar() {
    this.location.back();
  }

}